import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { FormattedMessage as T, useIntl } from "react-intl";
import { Severity, SnackbarMessageProps, snackbarStore } from "@knowfully/ui.common";
import translateError from "utils/translateError";

type GenericExportButtonProps = {
  exportData: () => Promise<void>;
  startIcon?: React.ReactNode;
  tooltipLabel?: string;
  exportButtonLabel?: string;
};

const GenericExportButton = ({
  exportData,
  startIcon,
  tooltipLabel,
  exportButtonLabel,
}: GenericExportButtonProps) => {
  const { formatMessage: t } = useIntl();

  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    const exportAsync = async () => {
      try {
        await exportData();
      } catch (error: any) {
        snackbarStore.update((s) => {
          s.snackbarMessage = new SnackbarMessageProps(
            translateError(error, t),
            Severity.Error
          );
        });
      } finally {
        setExporting(false);
      }
    };
    if (exporting) {
      exportAsync();
    }
  }, [exporting, exportData, t]);

  return (
    <Tooltip title={t({ id: tooltipLabel ?? "export" })}>
      <Button
        disabled={exporting}
        onClick={() => setExporting(true)}
        startIcon={startIcon ?? <FileDownloadIcon />}
      >
        <T id={exportButtonLabel ?? "export"} />
      </Button>
    </Tooltip>
  );
};

export default GenericExportButton;
